import { createSelector } from "reselect";

import { IRootState } from "../reducers";
import { IState } from "./types";

export const selectBusinessSettingsState = (state: IRootState): IState => {
  return state.businessSettings;
};

export const selectBusinessLogo = createSelector(
  [selectBusinessSettingsState],
  (state) => {
    return state.logoUrl;
  },
);

export const selectIsBusinessLogoFetching = createSelector(
  [selectBusinessSettingsState],
  (state) => {
    return state.isFetching;
  },
);

export const selectIsBusinessLogoUpdating = createSelector(
  [selectBusinessSettingsState],
  (state) => {
    return state.isUploading;
  },
);

export const selectIsBusinessLogoDeleting = createSelector(
  [selectBusinessSettingsState],
  (state) => {
    return state.isDeleting;
  },
);

export const selectBusinessLogoError = createSelector(
  [selectBusinessSettingsState],
  (state) => {
    return state.error;
  },
);

export const selectBusinessLogoDimensionWarnings = createSelector(
  [selectBusinessSettingsState],
  (state) => {
    return state.dimensionWarnings;
  },
);
